import {postCreateUser} from '../api/postCreateUser';
import {setUsers} from './setUsers';

const setCreateUser = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateUser(params);
            dispatch(setUsers({
                groups: params.groups,
                cashier: '',
            }));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setCreateUser
}